export function getNearbyDevicesArr(state) {
  return Object.values(state.device.nearbyDevices);
}

export function getPairedDevice(state, xmppLogin) {
  return state.device.pairedDevices[xmppLogin];
}
export function getPairedDevices(state) {
  return state.device.pairedDevices;
}
export function getPairedDevicesArr(state) {
  return Object.values(state.device.pairedDevices);
}

export function getFamilyDevices(state) {
  return getPairedDevicesArr(state).filter(
    (device) => device.group === "myDevices"
  );
}
export function getOtherDevices(state) {
  return getPairedDevicesArr(state).filter(
    (device) => device.group === "others"
  );
}

export function getDevicesToPair(state) {
  const pairedDevices = getPairedDevices(state);
  const nearbyDevices = getNearbyDevicesArr(state);

  return nearbyDevices.filter((device) =>
    pairedDevices[device.jid] ? false : true
  );
}
